import Link from "next/link";
import React from "react";

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type?: "button" | "submit" | "reset" | "label" | "link";
  size?: "sm" | "md" | "lg" | "xl";
  disabled?: boolean;
  styleType?: "outlined" | "fill";
  href?: string;
  variant?: "primary" | "secondary" | "danger" | "accent" | "neutral" | "base";
  className?: string;
  for?: string;
  shadow?: boolean;
}

const Button: React.FC<ButtonProps> = (params) => {
  const baseStyles = `btn btn-${params.size || "sm"} ${
    params.styleType === "outlined" ? "btn-outline" : ""
  } transition-all duration-300`;

  const variantStyles: Record<string, string> = {
    primary: `btn-primary `,
    secondary: `btn-secondary `,
    accent: `btn-accent `,
    neutral: `btn-neutral `,
    danger: `btn-error `,
    base: ``,
  };

  if (params.type == "label") {
    return (
      <label
        htmlFor={params.for}
        onClick={params.onClick}
        className={`${baseStyles} ${variantStyles[params.variant!]} ${
          params.disabled ? "opacity-50 cursor-not-allowed" : ""
        } ${params.className}`}
      >
        {params.children}
      </label>
    );
  } else if (params.type == "link") {
    return (
      <Link
        type={params.type}
        href={params.href!}
        className={`${baseStyles} ${variantStyles[params.variant!]} ${
          params.disabled ? "opacity-50 cursor-not-allowed" : ""
        } ${params.className}`}
      >
        {params.children}
      </Link>
    );
  }

  return (
    <button
      type={params.type!}
      onClick={params.onClick}
      disabled={params.disabled}
      className={`${baseStyles} ${variantStyles[params.variant!]} ${
        params.disabled ? "opacity-50 cursor-not-allowed" : ""
      } ${params.className}`}
    >
      {params.children}
    </button>
  );
};

export default Button;
